import { DEFAULT_LANGUAGE, isLanguageSelectable } from './languages';

const COOKIE_NAME = 'rc_lang';
const OFFER_DISMISSED_KEY = 'rc_lang_offer_dismissed';
const EXPLICIT_CHOICE_KEY = 'rc_lang_explicit';

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name: string, value: string, days = 365): void {
  if (typeof document === 'undefined') return;
  const maxAge = days * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

export function getStoredVisitorLanguage(): string | null {
  try {
    const fromLs = localStorage.getItem(COOKIE_NAME);
    if (fromLs && isLanguageSelectable(fromLs)) return fromLs;
  } catch {
    /* ignore */
  }
  const fromCookie = readCookie(COOKIE_NAME);
  if (fromCookie && isLanguageSelectable(fromCookie)) return fromCookie;
  return null;
}

export function setStoredVisitorLanguage(code: string): void {
  try {
    localStorage.setItem(COOKIE_NAME, code);
    localStorage.setItem(EXPLICIT_CHOICE_KEY, '1');
  } catch {
    /* ignore */
  }
  writeCookie(COOKIE_NAME, code);
}

export function hasExplicitLanguageChoice(): boolean {
  try {
    return localStorage.getItem(EXPLICIT_CHOICE_KEY) === '1';
  } catch {
    return false;
  }
}

export function isLanguageOfferDismissed(): boolean {
  try {
    return localStorage.getItem(OFFER_DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissLanguageOffer(): void {
  try {
    localStorage.setItem(OFFER_DISMISSED_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function resolveInitialLocale(profileLang?: string | null): string {
  if (profileLang && isLanguageSelectable(profileLang)) {
    return profileLang;
  }
  const stored = getStoredVisitorLanguage();
  if (stored) return stored;
  return DEFAULT_LANGUAGE;
}
